Handlebars.registerPartial('partials/uitk/map-infowindow', Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=map-infowindow>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"secondaryContent") || (depth0 != null ? lookupProperty(depth0,"secondaryContent") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"secondaryContent","hash":{},"data":data,"loc":{"start":{"line":1,"column":26},"end":{"line":1,"column":48}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"useData":true}));